import type { GeneratedSchemaKind } from '@cli-types/core-engine/add-field.js'
import type { FormField } from '@cli-types/core-engine/schema.js'
import type { PromptFieldOptions, SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { applyAdvancedOptions } from './apply-advanced-options.js'
import { promptChildFields } from './prompt-child-fields.js'

export async function promptFormContainerField(
  context: SchemaPromptContext,
  kind: GeneratedSchemaKind,
  schemasDir: string,
  scope: 'schema' | 'list-item',
  name: string,
  label: string,
  type: string,
  depth: number,
  options: PromptFieldOptions
): Promise<FormField> {
  const field = {
    name,
    type,
    label,
    fields: []
  } as FormField

  await applyAdvancedOptions(context, field, kind, type, options)
  await promptChildFields(
    context,
    kind,
    schemasDir,
    type === 'list' ? 'list-item' : scope,
    field.fields!,
    depth,
    options
  )
  return field
}
